"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var social_groups_api_1 = require("@wix/social-groups-api");
var store_1 = require("./store");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/BaseWidgetController");
var helpers_1 = require("../helpers");
var main_1 = require("../main");
var FeedController = /** @class */ (function (_super) {
    tslib_1.__extends(FeedController, _super);
    function FeedController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.pageReady = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setFeed()];
                    case 1:
                        _a.sent();
                        this.bindActions();
                        this.feedStore.fetch();
                        mobx_1.autorun(function () {
                            var store = serializr_1.serialize(_this.feedStore);
                            _this.setProps({
                                feedItems: store.feedItems,
                            });
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    FeedController.prototype.setFeed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contextTokenRepository, groupId, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contextTokenRepository = new social_groups_api_1.ContextTokenService(this.getSiteToken(), this.getApiBaseUrl());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getGroupId()];
                    case 2:
                        groupId = _a.sent();
                        this.feedRepository = new social_groups_api_1.SocialContentService(this.getSiteToken(), groupId, contextTokenRepository);
                        this.feedStore = new store_1.FeedStore(this.feedRepository);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        main_1.MainController.logger.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FeedController.prototype.getGroupId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var api, group, location, _a, groupId;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isEditorMode()) return [3 /*break*/, 2];
                        api = new social_groups_api_1.default(this.getSiteToken(), this.getApiBaseUrl());
                        return [4 /*yield*/, helpers_1.getFirstGroup(api)];
                    case 1:
                        group = _b.sent();
                        return [2 /*return*/, group.groupId];
                    case 2:
                        location = this.controllerConfig.wixCodeApi.location;
                        _a = location.path, groupId = _a[1];
                        return [2 /*return*/, groupId];
                }
            });
        });
    };
    FeedController.prototype.bindActions = function () {
        this.setProps({
            createFeedItem: this.feedStore.create.bind(this.feedStore),
            commentFeedItem: this.feedStore.comment.bind(this.feedStore),
        });
    };
    FeedController.prototype.setProps = function (props) {
        return this.controllerConfig.setProps(props);
    };
    return FeedController;
}(BaseWidgetController_1.BaseWidgetController));
exports.FeedController = FeedController;
//# sourceMappingURL=controller.js.map